import { X, GripHorizontal } from 'lucide-react';
import type { ContextBlock } from '@netsuite-ai/types';

interface Props {
  value: ContextBlock[];
  onChange: (v: ContextBlock[]) => void;
}

export default function ContextBlocks({ value, onChange }: Props) {
  function add() {
    onChange([...value, { label: '', content: '' }]);
  }

  function remove(i: number) {
    onChange(value.filter((_, j) => j !== i));
  }

  function update(i: number, field: keyof ContextBlock, v: string) {
    onChange(value.map((b, j) => (j === i ? { ...b, [field]: v } : b)));
  }

  return (
    <div className="space-y-3">
      {value.map((block, i) => (
        <div
          key={i}
          className="bg-ink/8 flex flex-col items-start gap-2 rounded-sm px-2 py-2"
        >
          <div className="flex w-full items-center justify-between">
            <div className="text-ink flex cursor-grab items-center gap-1">
              <GripHorizontal size={16} />
              <p className="text-base font-medium">Context block</p>
            </div>
            <button
              onClick={() => remove(i)}
              className="text-ink flex items-center justify-center hover:text-neutral-600"
              aria-label="Remove"
            >
              <X size={16} />
            </button>
          </div>
          <div className="w-full overflow-hidden rounded border border-neutral-200 bg-neutral-50">
            <input
              type="text"
              value={block.label}
              placeholder="Label"
              onChange={(e) => update(i, 'label', e.target.value)}
              className="w-full bg-transparent px-3 pt-2 pb-1 text-sm font-medium outline-none placeholder:text-neutral-400"
            />
            <textarea
              rows={2}
              value={block.content}
              onChange={(e) => update(i, 'content', e.target.value)}
              className="w-full resize-none bg-transparent px-3 pb-2 text-sm outline-none"
            />
          </div>
        </div>
      ))}
      <button
        onClick={add}
        className="w-full rounded border border-dashed border-neutral-300 py-2 text-sm text-neutral-500 hover:bg-neutral-50"
      >
        Add context block
      </button>
    </div>
  );
}
